import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import RegistrationOption from "./registration_option";
import AddOnList from "./add_on_list";
import HiddenFormFields from "./hidden_form_fields";

const OpenRegistrationLayout = () => {
  const registration_type = useSelector(state => state.registration_type);

  useEffect(() => {
    const selectedType = document.querySelector('input[name="payment_type"]:checked');
    if (selectedType && selectedType.value === 'check_in') {
      const saveButton = document.querySelector('input.save_registration_form');
      if (saveButton) {
        const shouldDisable = !registration_type?.name;
        saveButton.disabled = shouldDisable;
        if (shouldDisable) {
          saveButton.classList.add('disabled');
        } else {
          saveButton.classList.remove('disabled');
        }
      }
    }
  }, [registration_type]);

  return (
    <div className="open-registration-layout-wrapper">
      <div className="registration-flex-container">
        <RegistrationOption />
        <AddOnList />
      </div>
      <HiddenFormFields />
    </div>
  );
}

export default OpenRegistrationLayout;